import { IWorkbookDataFreshnessInfo } from '~src/ts/models/IDataFreshnessInfo';
import { Workbooks } from '~src/workbook/resources/Workbooks';

import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { IWorkbookDetailInfo } from '../models/IWorkbookInfo';

export function fetchWorkbookById(workbookId: string): Promise<IWorkbookDetailInfo> {
  return Workbooks.getById(workbookId);
}

export function getExtractDraftId(workbookId: string): Promise<IResult> {
  return Workbooks.getExtractDraftId(workbookId);
}

export function fetchDataFreshnessPolicyByWorkbookId(workbookId: string): Promise<IWorkbookDataFreshnessInfo> {
  return Workbooks.getDataFreshnessPolicyById(workbookId);
}
